function l(a) {
  ["1", "2", "3", "4", "5", "6"].forEach((t) => {
    a.addBinding({
      key: t,
      shortKey: !0,
      altKey: !0
    }, function(e, o) {
      var r;
      ((r = o.format) == null ? void 0 : r.header) === Number(t) ? this.quill.removeFormat(e) : this.quill.formatLine(e, "header", t);
    });
  });
}
export {
  l as attachShortcuts
};
